module.exports = __webpack_public_path__ + "img/infinity8_bg.f503314c.png";